<template>
	<div>
		<div class="z-depth-1 spacein">
			<div class="row">
				<div class="col s10 m10 l10 xl10">
					<h5>Avaliação da Ação</h5>
				</div>
				<div class="col s2 m2 l2 xl2">
					<a data-tooltip="Adicionar um ítem" href="/aval-items/projeto" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">add</i></a>
				</div>
			</div>
			<div class="row">
				<div class="col s12 m12 l12 xl12">
					<table>
						<thead>
							<tr>
								<th>#</th>
								<th>Nome</th>
								<th>Peso</th>
								<th>Nota mínima</th>
								<th>Nota máxima</th>
								<th>Variação</th>
								<th>Editar</th>	
								<th>Remover</th>		
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in listaItensProj">
								<td>{{ index + 1 }}</td>
								<td>{{ item.nome }}</td>
								<td>{{ item.peso }}</td>
								<td>{{ item.nota_min }}</td>
								<td>{{ item.nota_max }}</td>
								<td>{{ item.nota_var }}</td>
								<td>
									<a data-tooltip="Editar um item" :href="'/aval-items/projeto/' + item.id" class="waves-effect waves-light btn-small tooltipped">
									  <i class="material-icons">edit</i>
									</a>
								</td>
								<td>
									<a data-tooltip="Remover um item" @click="onDelete('projeto', item.id)" class="waves-effect waves-light btn-small tooltipped">
									  <i class="material-icons">delete</i>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		
		<br><br>
		
		<div class="z-depth-1 spacein">
			<div class="row">
				<div class="col s10 m10 l10 xl10">
					<h5>Avaliação da Atuação Artístico-Cultural</h5>
				</div>
			</div>
			<div>
				<fieldset>
					<legend>Subgrupos de Aspectos Artísticos</legend>
					<div class="row">
						<div class="col s1 m1 l1 xl1 right">
							<a data-tooltip="Adicionar um subgrupo" href="/aval-items/subgrupo" class="cyan waves-effect waves-light btn-small left tooltipped">
							<i class="material-icons">add</i></a>
						</div>
					</div>
					
					<div class="row">
						<div class="col s12 m12 l12 xl12">
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Nome</th>
										<th>Editar</th>	
										<th>Remover</th>		
									</tr>
								</thead>
								<tbody>
									<tr v-for="(sub, index) in listaSubgrupos">
										<td>{{ index + 1 }}</td>
										<td>{{ sub.nome }}</td>
										<td>
											<a data-tooltip="Editar um subgrupo" :href="'/aval-items/subgrupo/' + sub.id" class="waves-effect waves-light btn-small tooltipped">
											  <i class="material-icons">edit</i>
											</a>
										</td>
										<td>
											<a data-tooltip="Remover um subgrupo" @click="onDelete('subgrupo', sub.id)" class="waves-effect waves-light btn-small tooltipped">
											  <i class="material-icons">delete</i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>		
				</fieldset>
				
				<fieldset>
					<legend>Ítens de Avaliação</legend>
					<div class="row">
						<div class="col s1 m1 l1 xl1 right">
							<a data-tooltip="Adicionar um ítem" href="/aval-items/artistico-cultural" class="cyan waves-effect waves-light btn-small left tooltipped">
							<i class="material-icons">add</i></a>
						</div>
					</div>
					<div class="row">
						<div class="col s12 m12 l12 xl12">
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Nome</th>
										<th>Grupo</th>
										<th>Subgrupo</th>
										<th>Nota mínima</th>
										<th>Nota máxima</th>
										<th>Variação</th>
										<th>Editar</th>	
										<th>Remover</th>		
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listaItensArtes">
										<td>{{ index + 1 }}</td>
										<td>{{ item.nome }}</td>
										<td>{{ item.grupo }}</td>
										<td>{{ item.avalSubgrupo? item.avalSubgrupo.nome : ''}}</td>
										<td>{{ item.nota_min }}</td>
										<td>{{ item.nota_max }}</td>
										<td>{{ item.nota_var }}</td>
										<td>
											<a data-tooltip="Editar um item" :href="'/aval-items/artistico-cultural/' + item.id" class="waves-effect waves-light btn-small tooltipped">
											  <i class="material-icons">edit</i>
											</a>
										</td>
										<td>
											<a data-tooltip="Remover um item" @click="onDelete('artistico-cultural', item.id)" class="waves-effect waves-light btn-small tooltipped">
											  <i class="material-icons">delete</i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</fieldset>
				<fieldset>
					<legend>Peso</legend>
					<div class="row">
						<div class="col s12 m12 l12 xl12">
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Grupo</th>
										<th>Peso</th>
										<th>Editar</th>			
									</tr>
								</thead>
								<tbody>
									<template v-for="(item, index) in listaItensArtes">
										<tr v-if="index == 0 || listaItensArtes[index].grupo != listaItensArtes[index - 1].grupo">
											<td>{{ index + 1 }}</td>
											<td>{{ item.grupo }}</td>
											<td>{{ item.peso }}</td>
											<td>
												<a data-tooltip="Editar o peso" :href="'/aval-items/' + (item.grupo).toLowerCase().replace(' ', '-') + '-peso'" class="waves-effect waves-light btn-small tooltipped">
												  <i class="material-icons">edit</i>
												</a>
											</td>
										</tr>
									</template>
								</tbody>
							</table>
						</div>
					</div>
				</fieldset>
				<fieldset>
					<legend>Notas máximas</legend>
					<div class="row">
						<div class="col s12 m12 l12 xl12">
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Grupo</th>
										<th>Nota Máxima</th>
										<th>Editar</th>			
									</tr>
								</thead>
								<tbody>
									<tr v-for="(nota, index) in listaNotas" v-if='nota.grupo <= 3'>
										<td>{{ index + 1 }}</td>
										<td>{{ grupos[nota.grupo] }}</td>
										<td>{{ nota.nota_max }}</td>
										<td>
											<a data-tooltip="Editar a nota máxima" :href="'/aval-items/nota-maxima/' + nota.id" class="waves-effect waves-light btn-small tooltipped">
											  <i class="material-icons">edit</i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
		
		<br><br>
		
		<div class="z-depth-1 spacein">
			<div class="row">
				<div class="col s10 m10 l10 xl10">
					<h5>Avaliação do Currículo</h5>
				</div>
			</div>
			<fieldset>
				<legend>Formação</legend>
				<div class="row">
					<div class="col s12 m12 l12 xl12">
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Nome</th>
									<th>Editar</th>		
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listaItensForm">
									<td>{{ index + 1 }}</td>
									<td>{{ item.nome }}</td>
									<td>
										<a data-tooltip="Editar um item" :href="'/aval-items/formacao/' + item.id" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">edit</i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Produção Científica</legend>
				<div class="col s1 m1 l1 xl1 right">
					<a data-tooltip="Adicionar um ítem" href="/aval-items/producao" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">add</i></a>
				</div>
				<div class="row">
					<div class="col s12 m12 l12 xl12">
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Nome</th>
									<th>Pontos</th>
									<th>Editar</th>	
									<th>Remover</th>		
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listaItensProd">
									<td>{{ index + 1 }}</td>
									<td>{{ item.nome }}</td>
									<td>{{ item.pontos }}</td>
									<td>
										<a data-tooltip="Editar um item" :href="'/aval-items/producao/' + item.id" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">edit</i>
										</a>
									</td>
									<td>
										<a data-tooltip="Remover um item" @click="onDelete('producao', item.id)" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">delete</i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Peso</legend>
				<div class="col s11 m11 l11 xl11">
					<b>Peso: {{listaItensProd[0].peso}}</b>
				</div>
				<div class="col s1 m1 l1 xl1 right">
					<a data-tooltip="Editar peso" href="/aval-items/curr-peso" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">edit</i></a>
				</div>
			</fieldset>
			<fieldset>
				<legend>Notas máximas</legend>
				<div class="row">
					<div class="col s12 m12 l12 xl12">
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Grupo</th>
									<th>Nota Máxima</th>
									<th>Editar</th>			
								</tr>
							</thead>
							<tbody>
								<tr v-for="(nota, index) in listaNotas" v-if='nota.grupo >= 4 && nota.grupo < 7'>
									<td>{{ index + 1 }}</td>
									<td>{{ grupos[nota.grupo] }}</td>
									<td>{{ nota.nota_max }}</td>
									<td>
										<a data-tooltip="Editar a nota máxima" :href="'/aval-items/nota-maxima/' + nota.id" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">edit</i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
		</div>
		
		<br><br>
		
		<div class="z-depth-1 spacein">
			<div class="row">
				<div class="col s10 m10 l10 xl10">
					<h5>Avaliação dos Relatórios</h5>
				</div>
			</div>
			<fieldset>
				<legend>Campos</legend>
				<div class="col s1 m1 l1 xl1 right">
					<a data-tooltip="Adicionar um ítem" href="/aval-items/relatorios" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">add</i></a>
				</div>
				<div class="row">
					<div class="col s12 m12 l12 xl12">
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Nome</th>
									<th>Num. Caracteres</th>
									<th>Responsável</th>
									<th>Nota mínima</th>
									<th>Nota máxima</th>
									<th>Variação</th>
									<th>Editar</th>	
									<th>Remover</th>		
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listaItensRel">
									<td>{{ index + 1 }}</td>
									<td>{{ item.nome }}</td>
									<td>{{ item.tamanho }}</td>
									<td>{{ item.responsavel }}</td>
									<td>{{ item.nota_min }}</td>
									<td>{{ item.nota_max }}</td>
									<td>{{ item.nota_var }}</td>
									<td>
										<a data-tooltip="Editar um item" :href="'/aval-items/relatorios/' + item.id" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">edit</i>
										</a>
									</td>
									<td>
										<a data-tooltip="Remover um item" @click="onDelete('relatorios', item.id)" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">delete</i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Peso</legend>
				<div class="col s11 m11 l11 xl11">
					<b>Peso: {{listaItensRel[0].peso}}</b>
				</div>
				<div class="col s1 m1 l1 xl1 right">
					<a data-tooltip="Editar peso" href="/aval-items/relatorios-peso" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">edit</i></a>
				</div>
			</fieldset>
		</div>
		
		<br><br>
		
		<div class="z-depth-1 spacein">
			<div class="row">
				<div class="col s10 m10 l10 xl10">
					<h5>Avaliação da Atuação na SIAC</h5>
				</div>
			</div>
			<fieldset>
				<legend>Atuação do orientador na SIAC</legend>
				<div class="row">
					<div class="col s12 m12 l12 xl12">
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Nome</th>
									<th>Pontos</th>
									<th>Editar</th>			
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listaItensSiacOrientador">
									<td>{{ index + 1 }}</td>
									<td>{{ item.nome }}</td>
									<td>{{ item.pontos }}</td>
									<td>
										<a data-tooltip="Editar um item" :href="'/aval-items/siac-orientador/' + item.id" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">edit</i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Peso e nota máxima</legend>
				<div class='row'>
					<div class="col s11 m11 l11 xl11">
						<b>Peso: {{listaItensSiacOrientador[0].peso}}</b>
					</div>
					<div class="col s1 m1 l1 xl1 right">
						<a data-tooltip="Editar peso" href="/aval-items/siac-orientador-peso" class="cyan waves-effect waves-light btn-small left tooltipped">
						<i class="material-icons">edit</i></a>
					</div>
				</div>
				<div class='row'>
					<div class="col s11 m11 l11 xl11">
						<b>Nota máxima: {{listaNotas[4].nota_max}}</b>
					</div>
					<div class="col s1 m1 l1 xl1 right">
						<a data-tooltip="Editar nota máxima" :href="'/aval-items/nota-maxima/' + listaNotas[4].id" class="cyan waves-effect waves-light btn-small left tooltipped">
						<i class="material-icons">edit</i></a>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Atuação do Estudante na SIAC</legend>
				<div class="col s1 m1 l1 xl1 right">
					<a data-tooltip="Adicionar um ítem" href="/aval-items/siac-aluno" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">add</i></a>
				</div>
				<div class="row">
					<div class="col s12 m12 l12 xl12">
						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Nome</th>
									<th>Pontos</th>
									<th>Editar</th>	
									<th>Remover</th>		
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listaItensSiacAluno">
									<td>{{ index + 1 }}</td>
									<td>{{ item.nome }}</td>
									<td>{{ item.pontos }}</td>
									<td>
										<a data-tooltip="Editar um item" :href="'/aval-items/siac-aluno/' + item.id" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">edit</i>
										</a>
									</td>
									<td>
										<a data-tooltip="Remover um item" @click="onDelete('siac-aluno', item.id)" class="waves-effect waves-light btn-small tooltipped">
										  <i class="material-icons">delete</i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<legend>Peso</legend>
				<div class="col s11 m11 l11 xl11">
					<b>Peso: {{listaItensSiacAluno[0].peso}}</b>
				</div>
				<div class="col s1 m1 l1 xl1 right">
					<a data-tooltip="Editar peso" href="/aval-items/siac-aluno-peso" class="cyan waves-effect waves-light btn-small left tooltipped">
					<i class="material-icons">edit</i></a>
				</div>
			</fieldset>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VueAvalItensList",
		props: [
			'itens_proj',
			'itens_artes',
			'itens_prod',
			'itens_form',
			'itens_rel',
			'itens_siac_aluno',
			'itens_siac_orientador',
			'subgrupos',
			'notas_maximas',
			'var_grupo',
		],
		data () {
			return {
				listaItensProj: JSON.parse(this.itens_proj),
				listaItensArtes: JSON.parse(this.itens_artes),
				listaItensProd: JSON.parse(this.itens_prod),
				listaItensForm: JSON.parse(this.itens_form),
				listaItensRel: JSON.parse(this.itens_rel),
				listaItensSiacAluno: JSON.parse(this.itens_siac_aluno),
				listaItensSiacOrientador: JSON.parse(this.itens_siac_orientador),
				listaSubgrupos: JSON.parse(this.subgrupos),
				listaNotas: JSON.parse(this.notas_maximas),
				grupos: JSON.parse(this.var_grupo)
			}
		},
		computed: {
		},
		methods: {
			onDelete(tipo, id) {
				$.ajax({
					headers:{
					  'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
					},
					method:'DELETE',
					url:'/aval-items/' + tipo + '/' + id,
					success:function(result) {
						showMsg('Item removido com sucesso!', 200);
						window.setTimeout('window.location="/aval-items"', 1000);
					},
					error:function(result) {
						if (result.status == 403)
							showMsg('Subgrupo com itens não pode ser removido!', 0);
						else
							showMsg('Erro de permissão ao tentar eliminar o item!', 0);
					}
				});
			}
        },
    }
</script>
